var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "c-btn c-btn--invisible has-icon",
        attrs: { "aria-label": "Vis boliger som liste." },
        on: {
          click: function($event) {
            return _vm.updateListViewType("list")
          },
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.updateListViewType("cards")
          }
        }
      },
      [
        _c(
          "svg",
          {
            staticClass: "c-btn__icon c-btn__icon--toggle c-btn__icon--large",
            class: {
              "is-active": _vm.listType === "list"
            },
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 512 512"
            }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"
              }
            })
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "c-btn c-btn--invisible has-icon",
        attrs: { "aria-label": "Vis boliger som kort." },
        on: {
          click: function($event) {
            return _vm.updateListViewType("cards")
          },
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.updateListViewType("cards")
          }
        }
      },
      [
        _c(
          "svg",
          {
            staticClass: "c-btn__icon c-btn__icon--toggle c-btn__icon--large",
            class: {
              "is-active": _vm.listType === "cards"
            },
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 512 512"
            }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
              }
            })
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }